import { useMutation } from '@apollo/client';
import { Button, Form, Input, Modal, Result, Typography } from 'antd';
import { SEND_CONTACT_US } from 'gql/profile/mutations';
import { useAuthStateContext } from 'providers/Auth';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { showErrorMessage } from 'utils/showErrorMessage';

const { Title } = Typography;

const ContactUs = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isVisible, setVisible] = useState(false);
  const [isSucceed, setSucceed] = useState(false);
  const { user } = useAuthStateContext();

  const [sendContactUs, { loading }] = useMutation(SEND_CONTACT_US, {
    onCompleted() {
      setSucceed(true);
    },
    onError: err => showErrorMessage(err)
  });

  const onFinish = (values: { description: string }) => {
    sendContactUs({
      variables: {
        input: {
          first_name: user?.first_name,
          last_name: user?.last_name,
          phone_number: user?.phone,
          email: user?.email,
          description: values?.description
        }
      }
    });
  };

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
    setSucceed(false);
  };

  return (
    <>
      <Button onClick={() => setVisible(true)} block>
        {t('header.contact_us')}
      </Button>
      {isVisible && (
        <Modal
          title={
            isSucceed ? null : (
              <Title level={4}>{t('contact_us.how_can_help')}</Title>
            )
          }
          onCancel={onCancel}
          okText={t('contact_us.submit')}
          footer={isSucceed ? null : undefined}
          confirmLoading={loading}
          onOk={() => form.submit()}
          cancelButtonProps={{ disabled: loading }}
          closable={!loading}
          centered
          open
        >
          {isSucceed ? (
            <Result
              status="success"
              title={t('contact_us.success_title')}
              subTitle={t('contact_us.success_text')}
            />
          ) : (
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="description"
                rules={[{ required: true, message: '' }]}
              >
                <Input.TextArea className="contact-us-textarea" />
              </Form.Item>
            </Form>
          )}
        </Modal>
      )}
    </>
  );
};

export default ContactUs;
